import React, { Component } from 'react'
import Included from '../Included'
class Tick extends Component {

  constructor(props) {
    super(props)
  }

  render() {
    return(
      <section>
        <a className="anchor" id="pricetick"></a>
        <h2>Price Tick</h2>
        <p>The price and quantity elements each will span the full width of whatever wrapper they are placed in. In these examples, they are placed within a grid of 2 columns but fill width from mobile - this is using grid classes from Common UI. The up/down buttons
        will not grow in width but the currency and input value will.</p>
        <h5>Active State</h5>
        <ul className="form-fields grid">
          <li className="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-price">Price</label>
              <div className="tick__group">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i className="fa fa-minus"></i></button>
                <span className="tick__group--currency soft-quarter--sides">$</span>
                <input id="tick-price" type="text" className="text-input text-input--large tick__group--value" defaultValue="95.34"/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
          <li className="grid__col-12 grid__col-sm-2 grid__col-md-3 grid__col-lg-2 hard--right--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-quantity">Quantity</label>
              <div className="tick__group">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i className="fa fa-minus"></i></button>
                <input id="tick-quantity" type="text" className="text-input text-input--large tick__group--value" defaultValue="6"/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <ul className="form-fields grid">
          <li className="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-price">Price</label>
              <div className="tick__group">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i className="fa fa-minus"></i></button>
                <span className="tick__group--currency soft-quarter--sides">USD</span>
                <input id="tick-price" type="text" className="text-input text-input--large tick__group--value" defaultValue="95.34"/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <ul className="form-fields grid">
          <li className="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-price">Price</label>
              <div className="tick__group">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i className="fa fa-minus"></i></button>
                <span className="tick__group--currency soft-quarter--sides">$/lb</span>
                <input id="tick-price" type="text" className="text-input text-input--large tick__group--value" defaultValue="95.34"/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <ul className="form-fields grid">
          <li className="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-price">Price</label>
              <div className="tick__group">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i className="fa fa-minus"></i></button>
                <input id="tick-price" type="text" className="text-input text-input--large tick__group--value" defaultValue="95.34"/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <br/>
        <h5>Dynamic Currency Width</h5>
        <p>There may be occasions where the currency section of the component needs to increase in width, again the input field will reduce in size to accomodate.</p>
        <ul className="form-fields grid">
          <li className="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-price">Price</label>
              <div className="tick__group">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i className="fa fa-minus"></i></button>
                <span className="tick__group--currency soft-quarter--sides">$/Barrel</span>
                <input id="tick-price" type="text" className="text-input text-input--large tick__group--value" defaultValue="95.34" readOnly/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <br/>
        <h5>Compact Width</h5>
        <p>Here we have a more compact wrapper width and you can see the input field reducing in width to accomodate.</p>
        <ul className="form-fields grid">
          <li className="grid__col-9 grid__col-sm-2 hard--left--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-price">Price</label>
              <div className="tick__group">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i className="fa fa-minus"></i></button>
                <span className="tick__group--currency soft-quarter--sides">$</span>
                <input id="tick-price" type="text" className="text-input text-input--large tick__group--value" defaultValue="95.34" readOnly/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<ul class="form-fields grid">
  <li class="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">
    <div class="tick js-price-tick">
      <label for="tick-price">Price</label>
      <div class="tick__group">
        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>
        <span class="tick__group--currency soft-quarter--sides">$</span>
        <input id="tick-price" type="text" class="text-input text-input--large tick__group--value" value="95.34"/>
        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>
      </div>
    </div>
  </li>
  <li class="grid__col-12 grid__col-sm-2 hard--right--sm-and-up">
    <div class="tick js-price-tick">
      <label for="tick-quantity">Quantity</label>
      <div class="tick__group">
        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>
        <input id="tick-quantity" type="text" class="text-input text-input--large tick__group--value" value="6"/>
        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>
      </div>
    </div>
  </li>
</ul>`}</code></pre>
        <br/>
        <h5>Read Only State</h5>
        <p>To enable the read only state on the main field simply add the <code>readonly</code> attribute to you input element. The will prevent the
        user from manually entering values into the fields.</p>
        <ul className="form-fields grid">
          <li className="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-price">Price</label>
              <div className="tick__group">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i className="fa fa-minus"></i></button>
                <span className="tick__group--currency soft-quarter--sides">$</span>
                <input id="tick-price" type="text" className="text-input text-input--large tick__group--value" defaultValue="95.34" readOnly/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
          <li className="grid__col-12 grid__col-sm-2 grid__col-md-3 grid__col-lg-2 hard--right--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-quantity">Quantity</label>
              <div className="tick__group">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i className="fa fa-minus"></i></button>
                <input id="tick-quantity" type="text" className="text-input text-input--large tick__group--value" defaultValue="6" readOnly/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<ul class="form-fields grid">
  <li class="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">
    <div class="tick js-price-tick">
      <label for="tick-price">Price</label>
      <div class="tick__group">
        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>
        <span class="tick__group--currency soft-quarter--sides">$</span>
        <input id="tick-price" type="text" class="text-input text-input--large tick__group--value" value="95.34" readonly/>
        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>
      </div>
    </div>
  </li>
  <li class="grid__col-12 grid__col-sm-2 grid__col-md-3 grid__col-lg-2 hard--right--sm-and-up">
    <div class="tick js-price-tick">
      <label for="tick-quantity">Quantity</label>
      <div class="tick__group">
        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>
        <input id="tick-quantity" type="text" class="text-input text-input--large tick__group--value" value="6" readonly/>
        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>
      </div>
    </div>
  </li>
</ul>`}</code></pre>
        <br/>
        <h5>Disabled State</h5>
        <p>To disable the component add the <code>is-disabled</code> class to your <code>tick__group</code> element. This will visually change the
        component to a greyed-out appearance and prevent user interaction with the buttons and field.</p>
        <ul className="form-fields grid">
          <li className="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-price">Price</label>
              <div className="tick__group is-disabled">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down" disabled><i className="fa fa-minus"></i></button>
                <span className="tick__group--currency soft-quarter--sides">$</span>
                <input id="tick-price" type="text" className="text-input text-input--large tick__group--value" defaultValue="95.34" disabled/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up" disabled><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
          <li className="grid__col-12 grid__col-sm-2 grid__col-md-3 grid__col-lg-2 hard--right--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-quantity">Quantity</label>
              <div className="tick__group is-disabled">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down" disabled><i className="fa fa-minus"></i></button>
                <input id="tick-quantity" type="text" className="text-input text-input--large tick__group--value" defaultValue="6" disabled/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up" disabled><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<ul class="form-fields grid">
  <li class="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">
    <div class="tick js-price-tick">
      <label for="tick-price">Price</label>
      <div class="tick__group is-disabled">
        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down" disabled><i class="fa fa-minus"></i></button>
        <span class="tick__group--currency soft-quarter--sides">$</span>
        <input id="tick-price" type="text" class="text-input text-input--large tick__group--value" value="95.34" disabled/>
        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up" disabled><i class="fa fa-plus"></i></button>
      </div>
    </div>
  </li>
  <li class="grid__col-12 grid__col-sm-2 grid__col-md-3 grid__col-lg-2 hard--right--sm-and-up">
    <div class="tick js-price-tick">
      <label for="tick-quantity">Quantity</label>
      <div class="tick__group is-disabled">
        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down" disabled><i class="fa fa-minus"></i></button>
        <input id="tick-quantity" type="text" class="text-input text-input--large tick__group--value" value="6" disabled/>
        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up" disabled><i class="fa fa-plus"></i></button>
      </div>
    </div>
  </li>
</ul>`}</code></pre>
        <br/>
        <h5>Disabled Quantity Standalone State</h5>
        <p>To further remove the up/down buttons from the component you can add the <code>is-standalone</code> class to the <code>tick__group</code> element.</p>
        <ul className="form-fields grid">
          <li className="grid__col-6 grid__col-sm-1 hard--left--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-quantity">Quantity</label>
              <div className="tick__group is-disabled is-standalone">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down" disabled><i className="fa fa-minus"></i></button>
                <input id="tick-quantity" type="text" className="text-input text-input--large tick__group--value" defaultValue="6" disabled/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up" disabled><i className="fa fa-plus"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="tick js-price-tick">
  <label for="tick-quantity">Quantity</label>
  <div class="tick__group is-disabled is-standalone">
    <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down" disabled><i class="fa fa-minus"></i></button>
    <input id="tick-quantity" type="text" class="text-input text-input--large tick__group--value" value="6" disabled/>
    <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up" disabled><i class="fa fa-plus"></i></button>
  </div>
</div>`}</code></pre>
        <br/>
        <h5>Error State</h5>
        <p>Like forms, the error state for the Price Tick component can be invoked by adding an <code>has-error</code> class to the <code>tick__group</code>.</p>
        <ul className="form-fields grid">
          <li className="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">
            <div className="tick js-price-tick">
              <label htmlFor="tick-price">Price</label>
              <div className="tick__group has-error">
                <button className="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i className="fa fa-minus"></i></button>
                <span className="tick__group--currency soft-quarter--sides">$</span>
                <input id="tick-price" type="text" className="text-input text-input--large tick__group--value has-error" defaultValue="95.34"/>
                <button className="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i className="fa fa-plus"></i></button>
              </div>
              <div className="error error--small">This is an example of an error message</div>
            </div>
          </li>
        </ul>
        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="tick js-price-tick">
  <label for="tick-price">Price</label>
  <div class="tick__group has-error">
    <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>
    <span class="tick__group--currency soft-quarter--sides">$</span>
    <input id="tick-price" type="text" class="text-input text-input--large tick__group--value has-error" value="95.34"/>
    <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>
  </div>
  <div className="error error-small">This is an example of an error message</div>
</div>`}</code></pre>
        <br/>
        <h5>Events</h5>
        <p>To initiate an instance of the PriceTick component, use the following snippet:</p>
        <pre><code className="language-javascript">{`
var priceTickComponent = commonUI.initializePriceTick();
        `}</code></pre>
        <p>The up/down buttons have the <code>'up.commonui.pricetick'</code> & <code>'down.commonui.pricetick'</code> events attached to them so you can invoke a function when they are called like so:</p>
                <pre><code className="language-javascript">{`
// PRICE

var priceTickComponent = commonUI.initializePriceTick({
  selector: '.js-price-tick'
});

var priceTickElement = document.querySelector('.js-price-tick');

priceTickElement.addEventListener('up.commonui.pricetick', function () {
  var currentValue = parseFloat(priceTickComponent.componentInputElement.value)
  priceTickComponent.componentInputElement.value = (currentValue + 1)
}, false);

priceTickElement.addEventListener('down.commonui.pricetick', function () {
  var currentValue = parseFloat(priceTickComponent.componentInputElement.value)
  priceTickComponent.componentInputElement.value = (currentValue - 1)
}, false);

// QTY

var quantityTickComponent = commonUI.initializePriceTick({
  selector: '.js-price-tick-quantity'
});

var quantityTickElement = document.querySelector('.js-price-tick-quantity');

quantityTickElement.addEventListener('up.commonui.pricetick', function () {
  var currentValue = parseFloat(quantityTickComponent.componentInputElement.value)
  quantityTickComponent.componentInputElement.value = (currentValue + 1)
}, false);

quantityTickElement.addEventListener('down.commonui.pricetick', function () {
  var currentValue = parseFloat(quantityTickComponent.componentInputElement.value)
  quantityTickComponent.componentInputElement.value = (currentValue - 1)
}, false);
        `}</code></pre>
        <br/>
        <p>The below example simply increments/decrements the current value of the inputs. The property of <code>componentInputElement</code> will be the input element supplied, this class defaults to <code>.js-price-tick__value</code></p>
        <br/>
        <h5>Example</h5>

        <div className="iframe-container display--flex" style={{
          "height":"200px",
          "width": "100%",
          "margin": "0"
        }}>
          <iframe seamless srcDoc={`
            <html style="background-color: #efefef">
              <head>
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
                <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              </head>
                <body>
                  <div class="grid">
                    <div class="grid__col-sm-12 main">
                      <section style="max-width: 400px; margin: 0 auto; width: 100%;">
                        <ul class="form-fields">
                          <li class="push--bottom">
                            <div class="tick js-price-tick">
                              <label for="tick-price">Price</label>
                              <div class="tick__group">
                                <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>
                                <span class="tick__group--currency soft-quarter--sides">$</span>
                                <input id="tick-price" type="text" class="text-input text-input--large tick__group--value js-price-tick__value" value="95.34"/>
                                <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div class="tick js-price-tick-quantity">
                              <label for="tick-quantity">Quantity</label>
                              <div class="tick__group">
                                <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>
                                <input id="tick-quantity" type="text" class="text-input text-input--large tick__group--value js-price-tick__value" value="6"/>
                                <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </section>
                    </div>
                  </div>

                  <script type="text/javascript" src="js/commonUI.js"></script>
                  <script>
                    function init() {

                      // PRICE

                      var priceTickComponent = commonUI.initializePriceTick({
                        selector: '.js-price-tick'
                      });

                      var priceTickElement = document.querySelector('.js-price-tick');

                      priceTickElement.addEventListener('up.commonui.pricetick', function () {
                        var currentValue = parseFloat(priceTickComponent.componentInputElement.value)
                        priceTickComponent.componentInputElement.value = (currentValue + 1)
                      }, false);

                      priceTickElement.addEventListener('down.commonui.pricetick', function () {
                        var currentValue = parseFloat(priceTickComponent.componentInputElement.value)
                        priceTickComponent.componentInputElement.value = (currentValue - 1)
                      }, false);

                      // QTY

                      var quantityTickComponent = commonUI.initializePriceTick({
                        selector: '.js-price-tick-quantity'
                      });

                      var quantityTickElement = document.querySelector('.js-price-tick-quantity');

                      quantityTickElement.addEventListener('up.commonui.pricetick', function () {
                        var currentValue = parseFloat(quantityTickComponent.componentInputElement.value)
                        quantityTickComponent.componentInputElement.value = (currentValue + 1)
                      }, false);

                      quantityTickElement.addEventListener('down.commonui.pricetick', function () {
                        var currentValue = parseFloat(quantityTickComponent.componentInputElement.value)
                        quantityTickComponent.componentInputElement.value = (currentValue - 1)
                      }, false);
                    }
                    window.onload = init;
                  </script>
                </body>
              </html>
            `}>
          </iframe>
        </div>
        <br/><hr/>
      </section>
    )
  }

}

export default Tick



// WEBPACK FOOTER //
// ./styleguide/components/sections/Tick.js